import { render, staticRenderFns } from "./UserTimeline.vue?vue&type=template&id=6c2f80be&"
import script from "./UserTimeline.vue?vue&type=script&lang=js&"
export * from "./UserTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports